import React, { useState } from 'react';
import { CONFIG } from '../config';

// Helper function to compute the award based on final rank.
function getAward(rank) {
  if (rank >= 1 && rank <= 296) return "Semifinalist";
  if (rank >= 297 && rank <= 434) return "Distinguished Scholar";
  if (rank >= 435 && rank <= 817) return "Honor Roll";
  return ""; 
}

const winnersData = [
  "Maheen Imran Shaikh",
  "Rassul Zhunussov",
  "Pranava Senathipathi Kumar",
  "Tatev Dadian",
  "Anjali Sharma-Tiwari",
  "Ameya Shirguppe",
  "Zalea Nunes",
  "Anya Goel",
  "Arjun Karapakula",
  "Cyrus Law",
  "Ramona (Mona) Valiollahi",
  "Vishnu Vijay",
  "Jarupat Bulpakdi",
  "Toha Abedin",
  "Devesh Aggarwal",
  "Omar Emam",
  "Aanya Gupta",
  "Jacob Mingen Gu",
  "Turiya Misra",
  "Seokhwan Jang",
  "Darara Negussie Meskela",
  "Cyrus Ghane",
  "Aimee Yu Zhang",
  "Chen You'An",
  "Md Towhidur Rahman Sakib",
  "Mariam Tutayeva",
  "Kyle Anthony J. Roberto",
  "Shawn Kim",
  "Amna Abid",
  "Joshua Wung",
  "Lily Chen",
  "Armaan Diwan",
  "Saahil Shah",
  "Sai Likhith Karri",
  "Ameya Kharade",
  "Meruyert Amangeldy",
  "Jayden Joseph",
  "Sammit Chidambaram",
  "Charlotte Sze Wai Wong",
  "Aru Lesbek",
  "Abdullah Goraya",
  "Ojaswi Singh",
  "Subanth Nanda Kumar",
  "Catherine Yang",
  "Keerthana Anumukonda",
  "Pradhyumna Vasishta",
  "Devesh Tiwari",
  "Armin Stamate",
  "Amber Ho Yiu Chow",
  "Aharon Aguirre",
  "Jingyi Ling",
  "Jasmine Sun",
  "Kanushi Desai",
  "Fernando Alonso Cruz Ng Ying",
  "Abhinav Shah",
  "Neal Shandilya",
  "Daksh Mannadath",
  "Dhairya Mittal",
  "Ethan Wei",
  "Rudransh Singh Palta",
  "Iris Tong",
  "Rudra Boghani",
  "Maria Galicia",
  "Tanvi Nare",
  "Claire Cao",
  "Kevin Ouyang",
  "Liu Shuyu, Fish",
  "V. Sang",
  "Sultan Sailau",
  "Anahitaa Jain",
  "Sajeel Muhymin Vehra",
  "Adhvay Karthikeyan",
  "Sophia Hou",
  "Julia Maksimowicz",
  "Hina Yamamoto",
  "Timur Petanin",
  "Alijawad Peera",
  "Taeho Kim",
  "Isabella Podesta",
  "Abhijay Chaudhari",
  "Supriya Krishnamurthy",
  "Jack Agata Pexton",
  "Ishaan Shailesh Surve",
  "Yuvan Aggarwal",
  "Hridank Shukla",
  "Bhrigu Uppal",
  "Hayden Chen",
  "Michael Wang",
  "Panita Chantravekin",
  "William Liang",
  "Sanjith Sowrirajan",
  "Hyunbin Seo",
  "Akash Saran",
  "Adithya V. Sastry",
  "Kelly Lock",
  "Advait Swaminathan",
  "George Thomas",
  "Hridhaan Sanat Banerjee",
  "Uktamjon Komiljonov",
  "Roneet Dhar",
  "Neo Xuan Che",
  "Mehaan Sibal",
  "Kayley Xu",
  "Shankar Harikrishnan",
  "Annie Zhu",
  "Raymond Chen",
  "Venkata Anirudh Devireddy",
  "Martin Izquierdo",
  "Anya Gruteser",
  "Sahasrad Sathish",
  "Guransh",
  "Mardochee Joseph",
  "Colin Ding",
  "Sria Siva",
  "Zahid Syed",
  "Trashgim Mulosmani",
  "Hrishikesh Satish",
  "Vedh Reddy",
  "Rishit Anand",
  "Rachel Dina Rakower",
  "Srishti Hazra",
  "Arjun Desikan",
  "Sangwoo Kim",
  "Ishaan Kumar",
  "Boze Jia",
  "Aaryan Parveen",
  "Benjamin Vaccaro",
  "Ganendra Bisma Mahardika",
  "Hazem Taha",
  "Satya Sriram Kokonda",
  "Abdallah Roshdy Elsyed",
  "Aarav Trivedi",
  "Varun Kumar Hittuvalli",
  "Abhay Gupta",
  "Timothy Hajin Park",
  "Yufei (Joanna) Jiang",
  "Rafael Matteo Dollet",
  "Baruni Soni",
  "Ali Zaruov",
  "Ved Reddy",
  "Saketh SIngamsetty",
  "Omer Mescioglu",
  "Mishri Buddhadev",
  "Shivansh Shukla",
  "Ariana Kam",
  "Mikhail Ibrahim",
  "Sz Kiu Priscilla Leung",
  "Leon Jiaxing Yuan",
  "Aye Myatt Naing",
  "Ansh Gupta",
  "Varshith Vijjapu",
  "Srenithi Ganesa Moorthy",
  "Jonathan Liu",
  "Kriti.Atluri",
  "Morgan Selzler",
  "Mikhail Zotov Nikolaevich",
  "Muhammad Zayann Yasir",
  "Amir Mahmoud Ghanem",
  "Michelle Zhou",
  "Charlie Wang",
  "Alex Vladimir",
  "Yuqi Zhang",
  "Shengtian Hong",
  "Roshan Amurthur",
  "Siddharth Yenamandra",
  "Saket Parayil",
  "Chetas Aduri",
  "Neya Rajasingh",
  "Ariane McDermott",
  "Arjun Arobind Nair",
  "Marcus Deng",
  "Dhrithi Karavadi",
  "Jing Yao Yang",
  "Zachary Pan",
  "Lily Bombay",
  "Thora Mattina Gudmundsdottir",
  "Rafael Dollet",
  "Chloe Angela Li",
  "Avyukt Satish",
  "Anthony Wang",
  "Julian Moncarz",
  "Arav Kumar",
  "Shresta Morisetty",
  "Aiden Chun",
  "Rohan Manchanda",
  "Eashan Rautaray",
  "Dhruv Nair",
  "Jasper Tay",
  "Ishaan Kabra",
  "Julia Liang",
  "Akshay Thanipet Padmanabhan",
  "Arda Deniz Kanlƒ±",
  "Eliza Zdych",
  "Rheann Laureiz Sioco",
  "Tianle Liang",
  "Ha-Mim Rahman",
  "Shreeya Rao Lalam",
  "Leo Tang",
  "Lotus Gao",
  "Denis Boudaliez",
  "Russell Liu",
  "Kwan Tsz Kin",
  "Ozair Ahmad Khan",
  "Adi Yenuubarii",
  "Sayak Moulic",
  "Arth Dalsania",
  "Liang Zhiying",
  "Pradhyun Goud Akkala",
  "Mabel Yang",
  "Isabel Goh",
  "Mabinty Keita",
  "Rastin Emrani",
  "Divya Jayam",
  "Tristan Park",
  "Yongen Shen",
  "Joshua Huang",
  "Simone Maimon",
  "Adhrit Srinivasan",
  "Ayzah Salim Jujara",
  "Ghrini Sai Jella",
  "Lu Renyi",
  "Vrishank Adya Mallela",
  "Eshna Saigol",
  "Vihaan Kinra",
  "Sophie Katherine Huang",
  "Ajsel Budlla",
  "Aw Jun Hong",
  "Le Minh Ngoc",
  "Jeffrey Huang",
  "Aryan Kohli",
  "Bhargav Shah",
  "Sam-Haendell Thosiac",
  "Shiven Das",
  "Ahana Tajnim Khan",
  "Evelyn Yao",
  "Sai Akshith Challagolla",
  "Malak Omer",
  "Ivy Yuetian Ma",
  "Yao",
  "Lasya Gudibanda",
  "Arjun Skanda Ananda",
  "Sami Ihsan Sazci",
  "Samuel Han",
  "Arsh Jha",
  "Stella Myers",
  "Sai Raghav Ganesh",
  "Sreemahati Periyala",
  "Chloe Lam",
  "Adwita Jagannathan",
  "Yanrui Li",
  "Emily Nguyen",
  "Akhil Yalamanchili",
  "Anvith Neelam",
  "Yuancheng Luo",
  "Tanvi Gupta",
  "Attrey Koul",
  "Jade Lam",
  "Vethaanthikaa Karthikeyan",
  "Elie Ciril",
  "Chris Huy Nguyen",
  "Jyotirmay Meena",
  "Bhavya Babbellapati",
  "Elizabeth Vinokurov",
  "Rayhan Roswendi",
  "Chizorom Elleora Okoro",
  "Syeda Zainab Fatima",
  "Rishika Kurma",
  "Jaelyn Jin",
  "Diya Venkataragavan",
  "Heshika Vaitheeswaran",
  "Eshan Dheeraaj Geadam",
  "Prashasti Huliya",
  "Namay Khandelwal",
  "Ashika Sharma",
  "Akhil Kolluru",
  "Matthew Jun",
  "Nyel Ahmed Uffa",
  "Sahasra Yellepeddi",
  "Sufyan Ahmed",
  "Sharvani Mishra",
  "Noor Gowra",
  "Kenisha Verma",
  "Zian Da",
  "Zofia Rutkowska",
  "Aryaman Gupta",
  "Joonseong Lim",
  "Anandhitha Arasu",
  "Aaron Pinto",
  "Sanwarya Ramani",
  "Abhijay R Kodadala",
  "Ashish Mulabagili",
  "Benicio Olson",
  "Aditya Yadav",
  "Jahnavi Sharma",
  "Sophie Huang",
  "Aarushi Sharma",
  "Survani Sinha",
  "Roshini Selvakumar",
  "Abdullah Mohammed",
  "Ram Sumedh Besta",
  "Peerzada Shahmeer Alum",
  "Alastair Go",
  "C. Tibet Pozam",
  "Sofia Kazintseva",
  "Oechsel Theo",
  "Srishanth Ravi",
  "Muhammadyahyo",
  "Jordyn Szczesniak",
  "Klair Tan",
  "Elif Bilge Ka≈ü",
  "Aidan Wong",
  "Anshi Elizabeth Thomas",
  "Samaira Khan",
  "Siyeong Park",
  "Jinghan Zhang",
  "Alyson Henderson",
  "Claire Lily Huang",
  "Vyom Uppar",
  "Miguel Christopher Mok",
  "Deren Toker",
  "Tianyu Li",
  "Harshil Jegan",
  "Utsav Saroha",
  "Rithvik Sai Reddy Kambham",
  "Jiexi Pan",
  "Marie-Jose Rohayem",
  "Yeeun Choi",
  "Vihaan Gupta",
  "Tapasya Illuri",
  "Hedy Tang",
  "AldricBenala",
  "Atul Ganesh",
  "Jacquelyn Inocencio",
  "Siri Pulakandam",
  "Anoushka Swaminathan",
  "Srichandra Pallerla",
  "Roaran Katelan",
  "Anusha Sudheer",
  "Chunghyun Kawata",
  "Suhaan Khan",
  "Jobanjot Singh Madhok",
  "Laksan Mohan",
  "Reyo Apollo Schwilk Khan",
  "Morgan Gruber",
  "Eesha Vanamala",
  "Nimeesha Komatireddy",
  "Michelle Diep",
  "Feride Ada Senturk",
  "Iraj Gupta",
  "Yara Aziz",
  "Rohini Vedam",
  "Morgan Duran",
  "Sydney Yu",
  "Sumedha Saha",
  "Paridhi Goel",
  "Avika Taneja",
  "Deeksha Shashidhar",
  "Arjan Gavin Singh Waraich",
  "Briana Codrescu",
  "Yena Kim",
  "Lasya Pannala",
  "Aadhavan Veerendra",
  "Andrew Rahana",
  "Aarthi Palaniappan",
  "Rehan Raj",
  "Brooke Foley",
  "Arya Verma",
  "Veer Chopra",
  "William Flaxenburg",
  "Ashley Mahajan",
  "Norah Majed Altamimi",
  "Darshika Domma",
  "Tanya Yong",
  "Aryana Hou",
  "Sathwika Prasad",
  "Aishwarya Kamineni",
  "Collin Lu",
  "Tsz Chai Alan Liu",
  "Haidar Jamal Haidar Haidar",
  "Aaron Sethi",
  "Leo Chen",
  "Hayden Lee",
  "Arjun Vir Jain",
  "Kaushik Tatiraju",
  "Zoya Chowdhury",
  "Xinyi Kathy Xi",
  "Anika Gursahani",
  "Advithi Baddam",
  "Sofia Pisareva",
  "Ansel Belani",
  "Avery Huang",
  "Savya Bhat",
  "Mischa Neo Jing Yi",
  "Dhruva Vengala",
  "Rohith Kolar",
  "Nikhil Palempalle",
  "Mridul Jain",
  "Nicholas McDow",
  "Eslam Essam Ahmed",
  "Chaitra Jogiraju",
  "Eric Jia Zhang",
  "Grace Yuan",
  "Gagana Latchupatula",
  "Sean Haejun Lee",
  "Annalyse McGhee",
  "Narendran Karikkathil",
  "Parth Agarwal",
  "Lina AlKhayyal",
  "Oviya Mathi",
  "Pranav Mohankumar",
  "Petechapat Areewong",
  "Maya Trutschl",
  "Pranav Kunadharaju",
  "Aadi Shah",
  "Neel Jain",
  "Martin Joe Prem Kumar",
  "Jennie Zhang",
  "Jay Patel",
  "Piyush Acharya",
  "Sanjana Rajaram",
  "Wenshu Wang",
  "Stepan Galstyan",
  "Suraj Swaminathan",
  "Tavishi Sinha",
  "Reyansh Mohan Lal",
  "Kausthubha Naraparaju",
  "Jophy Lin",
  "Theodore Mui",
  "Ainsley Bosman",
  "Matthew Young Chi",
  "Ishaan Dabhade",
  "Akchara Mukunthu Deepak Babu",
  "Snehansh Reddy Bachala",
  "Srisaran Sivakumar",
  "Ainesh Yarlagadda",
  "Ying Yue Sakura Wang",
  "Gaon An",
  "Vivaan Awal",
  "Aleksei Medvedev",
  "Misha Tumma",
  "Shivansh Gupta",
  "Wenli Xie",
  "Nathan Tatsuya Tam",
  "Julia Gao",
  "Lizbeth He",
  "Pushkal Kumar",
  "Lamar Ayman Muslem Almuslem",
  "Chau Pham",
  "Syed Mohammad Hamza Warsi",
  "Alison Paez Kestler",
  "Vu Tam Minh",
  "Julian Sethna",
  "Kaytharee Lin Thant",
  "Pranavkrishna Bharanidharan",
  "Julianna Marton",
  "Adhrith Vutukuri",
  "Aryan Pant",
  "Kohei Kawada",
  "Eric Du",
  "Lokesh Pranav Karthik",
  "Sudharshini Ram",
  "Zara Kidwai",
  "Aditya Bhupesh Ghanekar",
  "Aneesh Karavadi",
  "Zainab Mustafa Bharmal",
  "Alicia Gu",
  "Ajay M Kota",
  "Katrina Javaisas Davis",
  "Arpit Kumar",
  "Owen Shi",
  "Sowmiya Deventhira Raja",
  "Auspy Li",
  "Apichat Chaisarn",
  "Cody Tang",
  "Wu Ka Chun",
  "Ruby Jingxuan Huang",
  "Preyahathai Aroonvanichporn",
  "Jahnavi Singh",
  "Aryan Mathur",
  "Manyata Neupane",
  "Auttakorn Wongchai",
  "Adithya Anand",
  "Tay Jie Rong Javyan",
  "Jovan Tran",
  "Zena Kishek",
  "Dominika Wierzchucka",
  "Can Deniz Yazici",
  "Maanit Misra",
  "Yuxin Wang",
  "Jathursha Thavaraajah",
  "Yahaya bin Basiron",
  "Anushka Musaddi",
  "Esabella Sodhi",
  "Luke Patrick Geltner",
  "Ramazan Kanat",
  "Aryan Bellamkonda",
  "Tungat Tomiris Muhamednurkyzy",
  "Ela Sismanyazici",
  "Sarintip Thipjumnun",
  "Gabriele Battimelli",
  "Umar Bobojonov",
  "Khrish Mukesh Butani",
  "Dorian Brian Reed",
  "Guilherme Andrade Decotelli",
  "Eman Khosa",
  "Niran Patel",
  "Sanjana Chandramohan",
  "Roshan Shameem",
  "Hiya Shyani",
  "Jia Sheng Clyde Siow",
  "Yoon Ting Jun Xiong",
  "Siena Susan Abraham",
  "Ridhima Abhijit Patil",
  "Prakhar Shrimali",
  "Marika Shimizu",
  "Geet Jaiswal",
  "Delfino Gonzalez",
  "Nguyen Huu An Nguyen",
  "Arnav Guduri",
  "Yuqiao Zhao",
  "Demir Gulen",
  "Divya Shrikanth",
  "Rithwik Nair",
  "Matthew Bock",
  "Taisiia Tymofieieva",
  "Tharun Vijay U.K.",
  "Wafi Sharif",
  "Charanarravindaa Suriess",
  "Aria Mitra",
  "Ved Khatri",
  "Irene Eun",
  "Mina Shyam",
  "Dhruthi Vinay Bharadhwaj",
  "Justin Tjitra",
  "Tina Ren",
  "Hitesh Konduru",
  "Aarush Upadhya",
  "Tarun Saibabu Chamala",
  "Ranviir Saini",
  "Aditya Sharma",
  "Saanvi Arun",
  "Walid El Ouarzazi",
  "Lily Shi",
  "Jeremy Wang",
  "Austin Rylan Xu",
  "Aiswharyaa Lalgudi Nagarajan",
  "Julia Shi",
  "Praneetha Ghattamaneni",
  "Divya Khandelwal",
  "Tom Le",
  "Nikhil Nunna",
  "Jayavardhan Harihar Prasad",
  "Chloe Sanada",
  "Kally Wen",
  "Princeton Lam",
  "Jarin Nudar",
  "Aadhrit Peram",
  "Rathish Raghav RamKumar",
  "Bui Anh Hao",
  "Vedansh Saha",
  "Yash Joshi",
  "Arinjay Banerjee",
  "Mario Orellana",
  "Christopher Ko",
  "Rihan Kachare",
  "Oliver (Zihuan) Xu",
  "Ibraheem Saqib",
  "Hansong Zuo",
  "Xizhe Yang",
  "Suhrit Revuri",
  "Jiwoo Kim",
  "Lily Ma",
  "Vivian Feng",
  "Siraaj Singh",
  "Presha Kashyap",
  "Surya Nikhita Fincke",
  "Asel Alibekova",
  "Diya Rajkumar",
  "Chak Hang Chan",
  "Rishith Aggarwal",
  "Cecily Lu",
  "Abhinav Nambi",
  "Ahmad Fikri Zulfikar",
  "Dhravarin Bhuanantanondh",
  "Dan Roby",
  "Adela Wang",
  "Rushil S Yeole",
  "Atharva Sahu",
  "Justin Yuan",
  "Maissie Navarro",
  "Spencer Hirsch",
  "Rejoy Rajesh",
  "Barnabas Kui",
  "Manan Shah",
  "Geetansh Dhuria",
  "Leo Toake",
  "Angela Davis",
  "Shravan Calvin Sridhara",
  "Fatima Zaheer",
  "Bennett Eisley",
  "Sarantina D.",
  "Nidhira Palakolanu",
  "Yew Zi Shuen",
  "Arav Srivastava",
  "Ansh Jain",
  "Adam Kui",
  "Alishba Abubakr Siddiq",
  "Logan Shaper",
  "Platon Gorokhov",
  "Marianna Shekoian",
  "Saisha Sahoo",
  "Riana Das",
  "Arshaan Khurana",
  "Jayden Chen",
  "Jiarui Jackie Li",
  "Shreya Munjal",
  "Selena Ghane",
  "Marsha Nath",
  "Kennard Liong",
  "Noran Hassan",
  "Dua Nadeem",
  "Saathvik Voora",
  "Isaac Xu",
  "Yoonha Lee",
  "Roberto Moura de Souza Leao",
  "Reethi Reddy Kumbham",
  "Julia Jose",
  "Siya Karani",
  "Georgia Marie Newberry",
  "Avani Malhotra",
  "Kairatov Assiretaly",
  "Manasvi Dhakite",
  "Angelina Lanskikh",
  "Maksym Turchenko",
  "Nannalin Pornprasertsom",
  "Pranav Kannan",
  "Sophia Alejandra Serra Bautista",
  "Tanisha Thaosen",
  "Dinmukhammed Kemelov",
  "Yi Han",
  "Hector Hinojosa",
  "Chua Leyang",
  "Vanya Karan Gupta",
  "Lavrentyev Artem",
  "Kaavya Bhatt",
  "Anya Chitturi",
  "Shiven Sharma",
  "Amrit Kar",
  "Qiu Caroline",
  "Shrey Jain",
  "Safiyakhon Zulfikarova",
  "Ajay Koumar Sassikoumar",
  "Noor Koshok",
  "Chloe Elkareh",
  "Shanaya Ailsinghani",
  "Gagan Chitragar",
  "Elaina Chen",
  "LIN, KAI-LUN",
  "Ashwin Ramachandran",
  "Mushekbayev Amir",
  "Himesh Mallula",
  "Fung Kai Jing Hay",
  "Puranjay Haldankar",
  "Vansh Shah",
  "Advika Sahney",
  "Amy Nangia",
  "Rishika Subudhi",
  "Aarya Kulkarni",
  "Ada Brunner",
  "Rachit Agarwala",
  "Yuriko Tanaka",
  "Allegra Baschiera",
  "Amy Nangia",
  "Sofia Teodora Dragomir",
  "Mikhail Aleksandrov",
  "Krishanu Karun",
  "Srirama Desiraju",
  "Linnea Nora Riehl",
  "Isaac Engel",
  "Kashika R",
  "Cindy Gu",
  "Jahnavi Balaji",
  "Mariana Barbosa Fialho",
  "Nathan Huang",
  "Vidyuth Pasumarthi",
  "Suchir Dubey",
  "Iraj Shroff",
  "Isabel Zhou",
  "Aadit Shrivastava",
  "Suin Jung",
  "Lorcan Purcell",
  "Adrian Huang",
  "Hui Ting Wai",
  "Emma Wang",
  "Nhat Minh Vu",
  "Maanit Khanna",
  "Kaavya Goel",
  "Tanushri Ciganehalli",
  "Sashwath Ravishankar",
  "Aiden Pereira",
  "Medha Dontineni",
  "Sai Abhiram Pathaneni",
  "Iva Talwar",
  "Jef Zember Gregorio",
  "Andrew Zhou",
  "Myesha Mahashin",
  "Om Mahesh Patel",
  "Shrividya Regadamilli",
  "Adelyne Kristie Pandji",
  "Jonathan Song",
  "Aanya Rampuria",
  "Nitya Dani",
  "Javier Leng Jae Shaen",
  "Navneeth Badhri",
  "Ariana Dharmendra",
  "Asher Larsen",
  "Abdullah Abdulrahman Alharbi",
  "Arnav Maharjan",
  "Shreyas Taduri",
  "Rishika",
  "Elaine Wynette Wijaya",
  "Bolat Dariya",
  "Sandhya Lakshmanan",
  "Vihaan Sawardekar",
  "Manit Murthy",
  "Aryan Chavda",
  "Dev Saxena",
  "Viren Chauhan",
  "Brent Dara Yi",
  "Sheryl Selvaraj",
  "Siddharth Manne",
  "Tanish Kadarapura",
  "Seraphim Soliman",
  "Sunwoo Whang",
  "Yared Atrsaw Andargei",
  "Jonathan Peter Zapris",
  "Rishabh Kharait",
  "Ridhvi Shetty",
  "Advait Singh",
  "Maggie Zheng",
  "Vsronica Xu",
  "Sameeha Sana",
  "Harper Carnahan",
  "Chinmay Patil",
  "Maryia Kisialiova",
  "Harihar Vadrevu",
  "Zion Zhang",
  "Danu Kim",
  "Nabiha Islam",
  "Prayagh Prabhakar",
  "Sukrit Kaur",
  "Sophia Annunziata",
  "Nguyen Khunh An",
  "Rocco John Rush",
  "Eunsul Kim",
  "Aarush Anand",
  "Aaqil Shaik",
  "Shubhi Jain",
  "Ethan Li Ngan Sun",
  "Carson Overholtzer",
  "Yerin Cho",
  "Kevin Guo",
  "Divya Thirumala",
  "Mukul",
  "Mohammad Ismail Sher",
  "Aanya Tripathi",
  "Sanjana Avvaru",
  "Pranav Kunisetty",
  "Serena Ni",
  "Ahilesh Sivakumar",
  "Batal Amirbek",
  "Jasmine Wong",
  "Arjun Srinivasan",
  "Aarush Gunukula",
  "Aashna Dhriti",
  "Jeremy Yang",
  "Nicole Vinod",
  "Sydney Choi",
  "Quang Anh Nguyen",
  "Samuel Fletcher Harris",
  "Peter Jiang",
  "Ray Tian",
  "Aneesh Bondugula",
  "Abhirama Sonny",
  "Abigail Qi",
  "Ethan Mitchell Kim",
  "Kaylee Song",
  "Anju Advani",
  "Ben Bui",
  "Ellen Wei",
  "Name",
  "Eshan Vijaykumar Patil",
  "Kinjal",
  "Roy Seligman",
  "Guneesha Kaur",
  "Saathvik Valvekar",
  "Pranav Yogeswaran",
  "Kaleb Lee",
  "Avyang Tiwari",
  "Rajiv Srivastava",
  "Eshaan Nidee",
  "Josh Karthikeyan",
  "Raunak Singh",
  "Anna Zavadski",
  "Vinayak Jinez Manikandan",
  "Mihana Nakajima",
  "Brianna Su",
  "Jacob Gaochen",
  "Ved Parag Bhagat",
  "Jorge Wu Wu",
  "Eric Chengyu Sun",
  "Matilda Thomas",
  "Stephen Tao",
  "Ashwin Raghav",
  "Haiqa Sajid",
  "Jenelle Sowah-Klu",
  "Rohan Modi"
];

function Winners() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterAward, setFilterAward] = useState('all');

  const filteredData = winnersData
    .map((name, index) => ({ name, rank: index + 1, award: getAward(index + 1) }))
    .filter(item => {
      const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesFilter = filterAward === 'all' || item.award === filterAward;
      return matchesSearch && matchesFilter;
    });

  const getAwardBadgeStyle = (award) => {
    const styles = {
      'Semifinalist': { bg: 'rgba(0, 77, 153, 0.1)', color: '#004d99' },
      'Distinguished Scholar': { bg: 'rgba(139, 69, 19, 0.1)', color: '#8B4513' },
      'Honor Roll': { bg: 'rgba(34, 139, 34, 0.1)', color: '#228B22' }
    };
    return styles[award] || { bg: '#f0f0f0', color: '#666' };
  };

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom: '40px' }}>
        <span style={{
          display: 'inline-block',
          padding: '6px 14px',
          borderRadius: '6px',
          backgroundColor: 'rgba(0, 77, 153, 0.08)',
          color: '#004d99',
          fontSize: '0.85rem',
          fontWeight: '600',
          marginBottom: '16px'
        }}>
          March 20, 2025
        </span>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '16px'
        }}>
          2025 Opens Results & Honor Roll
        </h2>
        <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7' }}>
          Complete results from the 2025 IRO Opens examination, including all award recipients.
        </p>
      </div>

      {/* Stats Cards */}
      <div style={{ display: 'flex', gap: '16px', marginBottom: '40px', flexWrap: 'wrap' }}>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '20px 28px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{ fontSize: '2rem', fontWeight: '700', color: '#004d99', margin: '0 0 4px 0' }}>296</p>
          <p style={{ fontSize: '0.85rem', color: '#666', margin: 0 }}>Semifinalists</p>
        </div>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '20px 28px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{ fontSize: '2rem', fontWeight: '700', color: '#8B4513', margin: '0 0 4px 0' }}>138</p>
          <p style={{ fontSize: '0.85rem', color: '#666', margin: 0 }}>Distinguished Scholars</p>
        </div>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '20px 28px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{ fontSize: '2rem', fontWeight: '700', color: '#228B22', margin: '0 0 4px 0' }}>383</p>
          <p style={{ fontSize: '0.85rem', color: '#666', margin: 0 }}>Honor Roll</p>
        </div>
      </div>

      {/* Search & Filter */}
      <div style={{ display: 'flex', gap: '16px', marginBottom: '30px', flexWrap: 'wrap' }}>
        <input
          type="text"
          placeholder="Search for a name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            flex: '1',
            minWidth: '250px',
            padding: '14px 20px',
            fontSize: '1rem',
            border: '1px solid #e8eef3',
            borderRadius: '10px',
            outline: 'none',
          }}
        />
        <select
          value={filterAward}
          onChange={(e) => setFilterAward(e.target.value)}
          style={{
            padding: '14px 20px',
            fontSize: '1rem',
            border: '1px solid #e8eef3',
            borderRadius: '10px',
            outline: 'none',
            cursor: 'pointer',
            background: '#fff'
          }}
        >
          <option value="all">All Awards</option>
          <option value="Semifinalist">Semifinalists</option>
          <option value="Distinguished Scholar">Distinguished Scholars</option>
          <option value="Honor Roll">Honor Roll</option>
        </select>
      </div>

      {/* Results Table */}
      <div style={{
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e8eef3',
        overflow: 'hidden'
      }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', color: '#1a1a2e', borderBottom: '1px solid #e8eef3', width: '80px' }}>Rank</th>
              <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: '600', color: '#1a1a2e', borderBottom: '1px solid #e8eef3' }}>Name</th>
              <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', color: '#1a1a2e', borderBottom: '1px solid #e8eef3', width: '180px' }}>Award</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item) => {
              const badgeStyle = getAwardBadgeStyle(item.award);
              return (
                <tr key={item.rank} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 16px', textAlign: 'center', color: '#666', fontSize: '0.9rem' }}>{item.rank}</td>
                  <td style={{ padding: '12px 16px', color: '#1a1a2e', fontWeight: '500', fontSize: '0.95rem' }}>{item.name}</td>
                  <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                    <span style={{
                      display: 'inline-block',
                      padding: '4px 12px',
                      borderRadius: '12px',
                      fontSize: '0.8rem',
                      fontWeight: '600',
                      backgroundColor: badgeStyle.bg,
                      color: badgeStyle.color
                    }}>
                      {item.award}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {filteredData.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginTop: '40px' }}>
          No results found
        </p>
      )}

      {/* Contact Info */}
      <div style={{
        marginTop: '40px',
        padding: '24px',
        backgroundColor: '#f8f9fa',
        borderRadius: '12px'
      }}>
        <p style={{ fontSize: '0.95rem', color: '#555', marginBottom: '8px' }}>
          If a certificate was not received, please email <a href={`mailto:${CONFIG.CONTACT_EMAIL}`} style={{ color: '#004d99', fontWeight: '600' }}>{CONFIG.CONTACT_EMAIL}</a>.
        </p>
        <p style={{ fontSize: '0.95rem', color: '#555', margin: 0 }}>
          If a semifinalist confirmation email was not sent, please email immediately with the full name and school from the same email used for registration.
        </p>
      </div>
    </div>
  );
}

export default Winners;
